import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessProjectRedirectRoute: InvariantJiraRoute = {
	name: 'classic-business-redirect',
	path: '/jira/core/projects/:projectKey',
	exact: true,
};
